import React, { useRef } from 'react';
import {
  FormWrapper,
  Title,
  ButtonLogin,
  Detail,
  FieldWrapper,
  Session,
  IconMail,
  RecaptchaWrapper
} from './styled';
import { COLORS } from '@app/src/ui';
import { reduxForm, Field } from 'redux-form';
import { renderInput } from '@app/src/common/Input/renderInput';
import * as validate from '@app/src/utils/validations';
import { Icon } from '@app/src/common/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { fetchForgotPassword } from '@app/src/common/session';
import { useHistory } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  handleSubmit?: Function;
}

export const Form: React.FC<Props> = ({ handleSubmit }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(state => state.session.password.isFetching);
  const recatpchaKey = process.env.API_KEY_RECAPTCHA;
  const recaptchaRef = useRef(null);

  const handleClickSubmit = (data): void => {
    console.log(data, 'data')
    const token = recaptchaRef.current.getValue();
    if (token) {
      dispatch(fetchForgotPassword(data, token));
      recaptchaRef.current.reset();
    }
  };

  const handleClickLogin = (e): void => {
    e.preventDefault();
    history.push('/inicia-tu-sesion');
  };

  return (
    <React.Fragment>
      <FormWrapper>
        <Title>¿Olvidaste tu contraseña?</Title>
        <Detail>Ingresa tu email y te enviaremos los pasos para cambiarla</Detail>
        <FieldWrapper>
          <Field
            name="email"
            placeholder="prueba@gmail.com"
            maxLength={80}
            component={renderInput}
            validate={[validate.required, validate.email]}
            iconLeft={<IconMail><Icon data-name="icon-mail" width="20" height="20" fill="#ccc" /></IconMail>}
          />
        </FieldWrapper>
        <RecaptchaWrapper>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey={recatpchaKey}
          />
        </RecaptchaWrapper>
        <ButtonLogin
          background={COLORS.BLACK}
          handleClick={handleSubmit(handleClickSubmit)}
          loading={isLoading}
          color="#fff"><strong>Enviar</strong>
        </ButtonLogin>
        <Session><a onClick={handleClickLogin}>Inicia sesión</a> en tu cuenta</Session>
      </FormWrapper>
    </React.Fragment>
  )
};

const FormForgotPasswordHoc = reduxForm({
  form: 'forgotPassword',
  initialValues: {
    email: ''
  }
})(Form);

export { FormForgotPasswordHoc as FormForgotPassword }
